module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qskel9-11334abf67213ec483cc7457591fd1a9.jpg";